import $ from '../../plugins/query.js';

// Used in many widgets to make the whole widget clickable.
// We do not want to set an A tag on the widget because of some styling problems.
// Link target is set in "data-href" attribute, LinkController parses HTML and hooks proper click events.
export default class LinkController {
    constructor(elem) {
        this.elem = elem;
        this.linkTarget = elem.dataset.href;
        this.isInIframe = window.parent !== window;
        this.newWindow = (('target' in elem.dataset) && (elem.dataset.target === '_blank') || this.isInIframe);
        this.registerClickEvent();
    }

    registerClickEvent() {
        if (this.linkTarget) {
            $(this.elem)
                .on('click', (event) => {
                    if (event.target.tagName.toLowerCase() !== 'a' || this.isInIframe) {
                        if (this.newWindow) {
                            window.open(this.linkTarget, '_blank');
                        }
                        else location.href = this.linkTarget;
                        return false;
                    }
                    return true;
                });
        }
    }

    static registerClickEventForElement(selector) {
        $(selector).find('.has-link').each((elem) => {
            new LinkController(elem); // eslint-disable-line no-new
        });
    }

    static init() {
        $(document).ready(() => {
            LinkController.registerClickEventForElement(document);
        });
    }
}
